import { render } from "./AbxSupportBanner.vue?vue&type=template&id=055d35cc&scoped=true"
import script from "./AbxSupportBanner.vue?vue&type=script&lang=js"
export * from "./AbxSupportBanner.vue?vue&type=script&lang=js"

import "./AbxSupportBanner.vue?vue&type=style&index=0&id=055d35cc&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d35cc"]])

export default __exports__